import 'core-js/es6/map';
import 'core-js/es6/set';
import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import './css/reset.sass'
import './css/theme.sass'
import './css/base/1_main.sass'
import './css/avn-components.sass'
import './css/support-hero-button.sass'
import * as serviceWorker from './serviceWorker';

// if (process.env.NODE_ENV !== 'production') {
//   const {whyDidYouUpdate} = require('why-did-you-update');
//   whyDidYouUpdate(React);
// }

ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();